import { render } from "./PostPreviewComponent.vue?vue&type=template&id=6e230043"
import script from "./PostPreviewComponent.vue?vue&type=script&lang=js"
export * from "./PostPreviewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__